<template>
  <v-navigation-drawer
      v-model="drawer"
      app color="#f0f0f0"
      style="z-index: 3; top:70px;  max-height: calc(100% - 70px); width: 300px;"
      right
      disable-resize-watcher
      v-if="checkMobile"
  >
    <v-container>
      <v-row>
        <v-col class="text-center">
          <span><strong class="member-name" @click="navigatePage('/myPage')">{{ userData.memberNm }}</strong>님, 안녕하세요</span>
        </v-col>
      </v-row>
    </v-container>
    <v-treeview
        :items="subMenus"
        class="menu"
        expand-icon=""
        open-on-click
        transition
        activatable
        item-key="name"
    >
      <template v-slot:append="{ item, open }">
        <v-icon v-if="item.children && item.children.length > 0" class="py-5">
          {{ open ? "expand_less" : "expand_more" }}
        </v-icon>
      </template>

      <template v-slot:label="{ item }">
        <div v-if="item.children && item.children.length > 0 && !item.path" class="menu py-3">
          {{ item.name }}
        </div>

        <div v-else @click="navigatePage(item.path)" class="menu py-3">
          {{ item.name }}
        </div>
      </template>
    </v-treeview>
    <v-row>
      <v-col class="d-flex justify-center align-center">
        <v-btn class="button" outlined @click="logout">로그아웃</v-btn>
      </v-col>
    </v-row>
  </v-navigation-drawer>
</template>

<script>
import _ from "lodash";
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'NavBar',
  props: ["isOpen"],
  data() {
    return {
      drawer: false,
      active: "",
      windowWidth: -1,
      subMenus: [
        // {
        //   name: "회원관리", path: "",
        //   children: [
        //     { name: "회원관리", path: "/member/manage", role: "ADMIN" }
        //   ]
        // },
        {
          name: "대출실적", path: "",
          children: [
            // 모바일 실적업로드 화면 제외
            // { name: "실적업로드", path: "/loan/perform/upload", role: "ADMIN" },
            { name: "실적통계", path: "/loan/statics", role: "ADMIN" },
            { name: "전체실적", path: "/loan/perform/total", role: "ADMIN" },
            { name: "팀별실적", path: "/loan/perform/team", role: "MANAGER" },
            { name: "개인실적", path: "/loan/perform/mine", role: "" },
            { name: "수수료계산기", path: "/loan/commission", role: "" }
          ]
        },
        {
          name: "게시판", path: "/board",
          children: [
            { name: "게시판관리", path: "/board/manage", role: "ADMIN" }
          ]
        },
        {
          name: "교육영상", path: "",
          children: [
            { name: "영상 목록", path: "/lecture", role: "" },
            { name: "교육영상 관리", path: "/lecture/manage", role: "ADMIN" },
            { name: "카테고리 관리", path: "/lecture/category", role: "ADMIN" }
          ]
        },
        // 추가 반영 예정
        {
          name: "증명서", path: "/certificate",
          children: []
        },
        {
          name: "론앤비즈", path: "/loanAndBiz",
          children: []
        },
        {
          name: "기타", path: "",
          children: [
            { name: "서비스 로그", path: "/etc/log", role: "ADMIN" }
          ]
        }
      ]
    }
  },
  computed: {
    ...mapGetters("login", {
      memberRole: "memberRole",
      userData: "userData"
    }),
    checkMobile(){
      // 모바일 화면에서 사이드 메뉴 열고 창을 확장시키면 사이드 메뉴가 사라지지 않는 오류 수정
      return (this.windowWidth < 1025);
    }
  },
  created() {

  },
  mounted() {
    this.windowWidth = window.innerWidth;
    window.addEventListener("resize", this.setWindowInnerWidth);
    this.setSubMenusList();
  },
  beforeDestroy() {
    window.removeEventListener("resize",this.setWindowInnerWidth)
  },
  methods: {
    ...mapActions("login", ["initData"]),
    navigatePage(path) {
      if (_.isEmpty(path)) {
        return false;
      } else if (path === "/loanAndBiz") {
        this.showAlert({message: "추후 업데이트 예정입니다"});
      } else {
        const routePath = path;
        if (this.$route.path !== routePath) {
          this.$router.push(routePath);
        }
      }
    },
    async logout() {
      this.initData().then(() => {
        this.$router.push("/");
        location.reload();
      })
    },
    setWindowInnerWidth(){
      this.windowWidth = window.innerWidth;
    },
    setSubMenusList() {
      this.subMenus = this.subMenus.map(menu => {
        let filteredSubMenu = [];

        if (this.memberRole === "ADMIN") {
          filteredSubMenu = menu.children.filter(subMenu => subMenu.role !== "USER");
        }
        if (this.memberRole === "MANAGER") {
          filteredSubMenu = menu.children.filter(subMenu => subMenu.role === "MANAGER" || subMenu.role === "");
        }
        if (this.memberRole === "USER") {
          filteredSubMenu = menu.children.filter(subMenu => subMenu.role === "" || subMenu.role === "USER");
        }

        return {
          ...menu,
          children: filteredSubMenu
        };
      }).filter(menu => menu.children.length > 0 || (menu.path !== "" && menu.children.length === 0));
    },
  }
}
</script>

<style>
.menu > div {
  border-bottom: 1px solid gray;
}
.v-treeview-node__children {
  background-color: #cfcfcf;
}
.activeMenu {
  color: white;
}
.member-name {
  text-decoration: underline;
}
.member-name:hover {
  cursor: pointer;
}
@media screen and (max-width: 1024px) {
  .logout-btn{
    float: right;
    margin: 25px 20px 20px 0;
    font-weight: 600;
  }
}
</style>